import {
  isMallIOS,
  isMallAndroid,
  isMCMallCirculationAndroid,
  isMCMallCirculationIOS,
  isMCMallKeyCustomerIOS,
  isMCMallKeyCustomerAndroid
} from '@mc/mc-base-env/src/web/platform.js'
import { miniProgramEnv } from './detect_mp'
import Url from '@mc/mc-utils/js/url/url'
import { getCookie } from '@/utils/cookie'

import { isMeicaiHarmony } from './get_app_info'

const parse = str => {
  let [thirdSource = '', thirdSourceContent = ''] = str.split('_')
  thirdSource === 'default' && (thirdSource = '')
  thirdSourceContent === 'default' && (thirdSourceContent = '')
  return {
    thirdSource,
    thirdSourceContent
  }
}

const getFromUrl = () => {
  const url = new Url(window.location.href)
  const queries = url.parseQuerystring()
  const hashQuery = url.Hash ? url.Hash.parseQuerystring() : {}
  const thirdSourceStr = queries.third_source || hashQuery.third_source
  if (thirdSourceStr) {
    return parse(thirdSourceStr)
  } else {
    return {
      thirdSource: '',
      thirdSourceContent: ''
    }
  }
}

const getFromCookie = () => {
  const str = getCookie('third_source')
  if (str) {
    return parse(str)
  } else {
    return undefined
  }
}

export const getThirdSource = () => {
  if (
    isMallIOS() ||
    isMallAndroid() ||
    isMCMallCirculationIOS() ||
    isMCMallCirculationAndroid() ||
    isMCMallKeyCustomerIOS() ||
    isMCMallKeyCustomerAndroid() ||
    isMeicaiHarmony()
  ) {
    return {
      thirdSource: '',
      thirdSourceContent: ''
    }
  }
  if (miniProgramEnv.isMiniProgram) {
    return getFromUrl()
  }
  const result = getFromCookie()
  if (result) {
    return result
  } else {
    return getFromUrl()
  }
}
